import { isEmpty, random } from 'radash';
import { GetProductDetailResponse, MeatCategoryResponse, ProductDescription, RecipeRelateResponse, Shops } from '@modules/libs/graphql/generated/graphql';
import { IDistributionChannel, IGeneralInfo, IMeatCategory, IProductDetail } from '@modules/products/domain/models/productDetail.model';
import { getLinkoutPrefixHttps } from '@shared/helpers/linkout.helper';
import { IRelatedRecipe } from '@shared/models/relatedRecipe.model';
export class ProductEntityMapper {
  public static toDomain(productDetailResponse: GetProductDetailResponse): IProductDetail {
    const {
      shops,
      slugUrl,
      id,
      title,
      shortDescription,
      tag,
      productIngredients,
      productDescription,
      nutrition,
      cooking,
      preserve,
      meatCategories,
      productCategories,
      recipe,
      images
    } = productDetailResponse;
    return {
      id,
      name: title,
      description: shortDescription,
      packshotUrl: images,
      tag,
      like: {
        isLiked: false,
        amount: 0
      },
      ingredients: productIngredients,
      generalInfo: this.productGeneralInfoMapper(productDescription),
      nutrition,
      cooking,
      preserve,
      distributionChannel: shops.length > 0 ? this.distributionChannelMapper(shops) : null,
      slugUrl: isEmpty(slugUrl) ? id.toString() : slugUrl,
      meatCategory: this.meatCategoryMapper(meatCategories),
      meatCategories: meatCategories.reduce((acc, {
        id
      }) => {
        if (id) acc.push(id);
        return acc;
      }, []),
      productCategories: productCategories.reduce((acc, {
        id
      }) => {
        if (id) acc.push(id);
        return acc;
      }, []),
      relatedRecipe: recipe.map((relatedRecipe: RecipeRelateResponse) => {
        return this.relatedRecipeMapper(relatedRecipe);
      })
    };
  }
  private static meatCategoryMapper(meatCategory: MeatCategoryResponse[]): IMeatCategory {
    return {
      id: meatCategory.length > 0 ? meatCategory[0].id : null
    };
  }
  private static productGeneralInfoMapper(productDescription: ProductDescription): IGeneralInfo {
    return {
      brand: productDescription.brand ?? '',
      brandLogo: productDescription.brandImg ?? '',
      category: productDescription.category,
      weight: productDescription.weight,
      amount: productDescription.amount,
      meatType: productDescription.meatType,
      allergen: productDescription.allergen,
      lifeBeforeOpen: productDescription.productStartDate,
      lifeAfterOpen: productDescription.productExpiredDate,
      fdaNumber: productDescription.fdaNumber
    };
  }
  private static distributionChannelMapper(distributionChannels: Shops[]): IDistributionChannel[] {
    return distributionChannels.map(({
      title,
      imageUrl,
      shopUrl
    }) => {
      return {
        title,
        imageUrl,
        linkout: getLinkoutPrefixHttps(shopUrl)
      };
    });
  }
  private static relatedRecipeMapper(relatedRecipeResponse: RecipeRelateResponse): IRelatedRecipe {
    const {
      id,
      title,
      slugUrl,
      thumbUrl,
      recipeMeatCategory
    } = relatedRecipeResponse;
    return {
      id,
      name: title,
      slug: isEmpty(slugUrl) ? id.toString() : slugUrl,
      imageUrl: thumbUrl,
      viewer: random(0, 50000),
      tag: recipeMeatCategory.map(({
        title
      }) => title)
    };
  }
}